module.exports = __webpack_public_path__ + "frontStatic/img/transportation.89c5d738.png";